// Contract: allergens is null (not declared) or a subset of these 14 codes; [] means "contains none".
export const ALLERGENS = [
    'gluten',
    'crustaceans',
    'eggs',
    'fish',
    'peanuts',
    'soybeans',
    'milk',
    'nuts',
    'celery',
    'mustard',
    'sesame',
    'sulphites',
    'lupin',
    'molluscs',
] as const;

export type Allergen = (typeof ALLERGENS)[number];

export const DIETARY_TAGS = ['vegetarian', 'vegan', 'gluten-free', 'spicy'] as const;

export type DietaryTag = (typeof DIETARY_TAGS)[number];
